// English (F4) for sprint 4 (rooms, cleaning cupboard, kid lock, read-aloud, voice input).
export const kamersEn = {
    nav: {
        rooms: 'Rooms',
        cleaning: 'Cleaning',
        kidLock: 'Kid lock',
    },
    roomKind: {
        living: 'Living room',
        bedroom: 'Bedroom',
        utility: 'Utility room or cupboard',
    },
    rooms: {
        title: 'Rooms',
        intro: 'Every tablet belongs to a room. A room decides who you see on the tablet.',
        add: 'Room',
        addTitle: 'New room',
        everyone: 'Everyone',
        tablets: { one: '{count} tablet', other: '{count} tablets' },
        noTablet: 'No tablet yet',
        modeAgenda: 'Calendar and tasks',
        modeLogboek: 'Cleaning cupboard',
        open: 'Open',
        back: 'Rooms',
        name: 'Name',
        nameHint: "For example: Sam and Dan's room",
        kind: 'Kind of room',
        whoTitle: 'Who do you see on this tablet?',
        whoIntro: 'A bedroom tablet only shows the people who sleep there.',
        whoAll: 'Everyone',
        whoExplicit: 'Residents only',
        residents: 'Residents',
        residentsHint: 'Tap a face to turn it on or off.',
        noResidentsWarning: 'Choose who sleeps here, otherwise the tablet stays empty.',
        noResidentsUtility: 'Without residents, everyone can pick themselves on this tablet.',
        householdWide: 'Also show events for the whole family',
        showTitle: 'What does the tablet show?',
        showAgenda: 'Calendar and tasks',
        showAgendaHint: 'The regular board with today, the week and the tasks.',
        showLogboek: 'Cleaning cupboard',
        showLogboekHint: 'Big tiles: who did the laundry, who vacuumed.',
        a11yTitle: 'Accessibility on the tablet',
        readAloud: 'Read aloud',
        readAloudHint: 'Tap a picture and the tablet reads it out. Helpful for non-readers.',
        textSize: 'Text size',
        textNormal: 'Normal',
        textLarge: 'Large',
        textFar: 'Extra large',
        calmMotion: 'Calm motion',
        calmMotionHint: 'No moving celebrations, everything appears quietly.',
        sounds: 'Sound',
        tabletsTitle: 'Tablets in this room',
        tabletsEmpty: 'No tablet in this room yet.',
        moveHere: 'Move a tablet here',
        moveChoose: 'Choose a tablet',
        moved: '{name} is now in {room}.',
        lastSeen: 'last seen {ago}',
        save: 'Save',
        saved: 'Saved. The tablet shows it within a minute.',
        created: '{name} was added.',
        remove: 'Delete room',
        removeBlocked: 'Move the tablet to another room first.',
        removeTitle: 'Delete room?',
        removeBody: '{name} disappears. The history is kept.',
        removeConfirm: 'Delete',
        removed: '{name} was deleted.',
        lastRoom: 'A household keeps at least one room.',
        conflict: 'Someone else changed this room in the meantime. We loaded the latest version.',
        emptyTitle: 'A board for every room',
        emptyBody: 'Put a tablet in a bedroom or the utility room and choose who you see there.',
        notFound: 'This room does not exist (any more).',
    },
    cleaning: {
        title: 'Cleaning',
        add: 'Chore',
        tabTurn: 'Whose turn',
        tabHistory: 'History',
        tabItems: 'Chores',
        turnIntro: 'Whoever did a chore longest ago is up next.',
        status: { fresh: 'Just done', soon: 'Almost', due: 'Ready again' },
        every: { one: 'every day', other: 'every {count} days' },
        everyWeek: 'every week',
        every2Weeks: 'every 2 weeks',
        everyMonth: 'every month',
        lastBy: 'Last: {name}, {when}',
        never: 'Never done yet',
        turn: 'Up next',
        doneAction: 'Done…',
        doneTitle: '{item} done',
        who: 'Who',
        when: 'When',
        time: 'Time',
        whenHint: 'You can go back up to 30 days.',
        note: 'Note',
        logged: '{item}: done by {name}.',
        loggedNoPoints: 'Saved. No points: {name} already did it on {when}.',
        points: { one: '{count} star', other: '{count} stars' },
        alreadyBy: 'already done by {name}',
        deleted: 'deleted',
        source: { kiosk: 'on the tablet', app: 'in the app' },
        removeLog: 'Delete',
        removeLogTitle: 'Delete this time?',
        removeLogBody: '{name} no longer gets the points.',
        removeLogConfirm: 'Delete',
        logRemoved: 'Deleted.',
        negativeTitle: 'Balance goes negative',
        negativeBody: '{name} already spent the points. Delete anyway?',
        historyEmptyTitle: 'Nothing done yet',
        historyEmptyBody: 'As soon as someone logs something, you see it here.',
        filterAll: 'Everyone',
        filterLabel: 'Filter by member',
        showDeleted: 'Also show deleted',
        today: 'Today',
        yesterday: 'Yesterday',
        itemsIntro: 'Chores per place and how often they come back.',
        noLocation: 'No place',
        edit: 'Edit',
        archive: 'Remove',
        archived: '{name} was removed.',
        editorNew: 'New chore',
        editorEdit: 'Edit chore',
        itemName: 'Name',
        itemNameHint: 'Short and clear, for example: Start the washing machine',
        icon: 'Picture',
        location: 'Place',
        newLocation: 'New place…',
        newLocationName: 'Name of the place',
        howOften: 'How often',
        customDays: 'Number of days',
        pointsLabel: 'Points',
        pointsHint: 'At most once per period, even when more people do it.',
        participants: 'Who takes part',
        participantsHint: 'Nobody chosen = everyone.',
        saved: 'Saved.',
        conflict: 'This chore changed in the meantime. We loaded the latest version.',
        emptyTitle: 'No cleaning chores yet',
        emptyBody: 'Start with something that comes back often, like the washing machine.',
        emptyAction: 'Add chore',
        suggestions: 'Or start with an example',
        suggest: {
            laundry: 'Start the washing machine',
            hang: 'Hang up the laundry',
            bath: 'Clean the bathroom',
            vacuum: 'Vacuum',
            plants: 'Water the plants',
        },
        loadError: 'Something went wrong. Please try again.',
        retry: 'Try again',
    },
    kidLock: {
        title: 'Kid lock',
        intro: 'Useful when siblings tick off each other’s tasks. Off by default; the lock only applies on the tablet.',
        none: 'No lock',
        pin: 'PIN',
        picture: 'Picture code',
        since: 'since {when}',
        waiting: 'waiting until {time}',
        set: 'Set up',
        change: 'Change',
        sheetTitle: 'Kid lock for {name}',
        kindLabel: 'Kind of lock',
        noneHint: 'Anyone can tap for {name} on the tablet.',
        pinHint: '4 digits that {name} remembers.',
        pictureHint: '4 pictures in order. Let {name} choose them.',
        pinLabel: 'PIN (4 digits)',
        pinRepeat: 'Once more',
        pinMismatch: 'The two PINs are not the same.',
        pinInvalid: 'Choose exactly 4 digits.',
        pictureChosen: 'Chosen: {count} of 4',
        pictureClear: 'Clear',
        pictureInvalid: 'Choose 4 pictures.',
        pictureSlot: 'Picture {n}',
        saved: 'The kid lock of {name} was updated.',
        removed: 'The kid lock of {name} is off.',
        emptyTitle: 'No children yet',
        emptyBody: 'Add your children under Members first.',
        about: 'Forgotten? Set a new code here. Five wrong tries on the tablet means a short wait.',
    },
    picture: {
        fox: 'Fox',
        cat: 'Cat',
        rabbit: 'Rabbit',
        bear: 'Bear',
        panda: 'Panda',
        owl: 'Owl',
        lion: 'Lion',
        frog: 'Frog',
        turtle: 'Turtle',
    },
    voice: {
        dictate: 'Dictate',
        listening: 'Listening…',
        stop: 'Stop',
        heard: 'Heard: {text}',
        failed: 'I did not catch that. Please type it.',
    },
    kiosk: {
        entry: 'Cleaning',
        title: 'Cleaning cupboard',
        back: 'Back',
        who: 'Who did it?',
        hold: 'Hold your face until the circle is full',
        holdShort: 'Hold',
        status: { fresh: 'Just done', soon: 'Almost', due: 'Ready again' },
        never: 'never',
        justNow: 'just now',
        minutesAgo: { one: '{count} min', other: '{count} min' },
        hoursAgo: { one: '{count} hour', other: '{count} hours' },
        daysAgo: { one: '1 day', other: '{count} days' },
        goodJob: 'Well done, {name}!',
        /** Rustig, buiten het thema Kinderen (geen lof, geen sterren). */
        goodJobCalm: 'Done by {name}',
        stars: { one: '+{count} star', other: '+{count} stars' },
        alreadyDone: 'Already done by {name} at {time}. Thanks anyway!',
        alreadyDoneCalm: 'Already done by {name} at {time}.',
        oops: 'Oops',
        undone: 'Removed again',
        other: 'Something else…',
        otherTitle: 'What did you do?',
        sayIt: 'Say it',
        emptyTitle: 'No chores yet',
        emptyBody: 'Mum or dad sets them up in the app.',
        notSaved: 'Not saved yet, we will try again soon.',
        close: 'Close',
        lockAskPin: '{name}, what is your code?',
        lockAskPicture: '{name}, which pictures?',
        lockWrong: 'Try again',
        lockWait: 'Please wait…',
        lockDigit: 'Digit {digit}',
        lockErase: 'Erase',
        lockProgress: '{count} of 4',
        adhoc: {
            windows: 'Clean windows',
            sweep: 'Sweep',
            trash: 'Take out rubbish',
            dishes: 'Do the dishes',
            'tidy-up': 'Tidy up',
            'water-plants': 'Water plants',
            recycling: 'Glass and paper',
            'make-bed': 'Change the bed',
        },
    },
    speech: {
        at: 'at {time}',
        points: { one: '{count} star', other: '{count} stars' },
    },
    a11y: {
        skipToContent: 'Skip to content',
        mainNav: 'Main navigation',
    },
};
//# sourceMappingURL=kamers.en.js.map